import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MyClaimsRoutingModule } from './myclaims-routing.module';
import { MyClaimsComponent } from './myclaims.component'
import { HeaderGalleriesComponent } from '../../components/header-galleries/header-galleries.component';
import { ClaimListComponent } from '@components/my-claims/claim-list/claim-list.component';

@NgModule({
  declarations: [
    MyClaimsComponent,
    
  ],
  imports: [
    CommonModule,
    MyClaimsRoutingModule,
    HeaderGalleriesComponent,
    ClaimListComponent
  ]
})
export class MyClaimsModule { }
